import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { ThemePalette } from '@angular/material/core';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { ButtonType } from '@shared/enums/button-type';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent extends ComponentAbstract {
  protected cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  @Input() buttonType = ButtonType.DEFAULT;
  @Input() buttonColor: ThemePalette = 'primary';
  @Input() buttonLabel = '';
  @Input() buttonLabelCss = 'letter-spacing';
  @Input() buttonCss = 'step-button';
  @Input() attrDisabled = false;
  @Input() isLoading = false;
  @Input() declare type: 'button' | 'reset' | 'submit';
  @Input() leftIcon: string;

  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor() {
    super(inject(ChangeDetectorRef));
  }

  buttonClick() {
    this.clickEvent.emit();
  }
}
